import { createI18n } from 'vue-i18n'

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export default createI18n({
  locale: window.localStorage.getItem('VUE_APP_I18N_LOCALE') ? window.localStorage.getItem('VUE_APP_I18N_LOCALE') : process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: window.localStorage.getItem('VUE_APP_I18N_FALLBACK_LOCALE') ? window.localStorage.getItem('VUE_APP_I18N_FALLBACK_LOCALE') : process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages(),
  silentTranslationWarn: true,
  silentFallbackWarn: true
})
